module.exports = __webpack_public_path__ + "assets/img/icon_slogan.2b7b4859.jpg";